import EntityTable from "../../../../../common/Tables/EntityTable"
import { dateUtils } from "../../../../../utils/DateUtils";
import RestrictionEditor from "./RestrictionEditor";
import { isPlanDisabled } from "./restrictionDefaults";

const locale = navigator.language;

const RestrictionsList = ({ ratePlan, propertyId, onCreateRestriction, onUpdateRestriction, onDeleteRestriction, deleteRestriction, onError }) => {
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            minWidth: 300,
        }, {
            field: 'startDate',
            headerName: 'Start date',
            minWidth: 120,
            valueGetter: (params) => {
                if (!params.value) {
                    return '-';
                }
                const date = new Date(params.value);
                const dayOfWeek = date.toLocaleString(locale, { weekday: 'short' });
                return `${dayOfWeek} ${date.toLocaleDateString()}`;
            },
            align: 'center',
        }, {
            field: 'endDate',
            headerName: 'End date',
            minWidth: 120,
            valueGetter: (params) => {
                if (!params.value) {
                    return '-';
                }
                const date = new Date(params.value);
                const dayOfWeek = date.toLocaleString(locale, { weekday: 'short' });
                return `${dayOfWeek} ${date.toLocaleDateString()}`;
            },
            align: 'center',
        }, {
            field: 'minLos',
            headerName: 'Minimum LOS',
            minWidth: 120,
            colSpan: (params) => isPlanDisabled(params.row) ? 3 : 1,
            valueGetter: (params) => {
                if (isPlanDisabled(params.row)) {
                    return 'Rate plan disabled';
                }
                
                const multiplyMinLos = params.row.multiplyMinLos;
                const minLos = params.value;
                return `${minLos}${multiplyMinLos ? '*' : ''}`
            },
            type: 'number',
            align: 'center',
        }, {
            field: 'allowedCheckinDaysOfWeek',
            headerName: 'Enabled check-in',
            flex: 1,
            minWidth: 150,
            colSpan: (params) => isPlanDisabled(params.row) ? 0 : 1,
            valueGetter: (params) => {
                return params.value.map(dayOfWeek => dateUtils.getLocalizedDayName(dayOfWeek, navigator.language)).join(', ');
            }
        }, {
            field: 'allowedCheckoutDaysOfWeek',
            headerName: 'Enabled check-out',
            flex: 1,
            minWidth: 150,
            colSpan: (params) => isPlanDisabled(params.row) ? 0 : 1,
            valueGetter: (params) => {
                return params.value.map(dayOfWeek => dateUtils.getLocalizedDayName(dayOfWeek, navigator.language)).join(', ');
            }
        }, {
            field: 'selectedRooms',
            headerName: 'Selected rooms',
            flex: 1,
            minWidth: 200,
            valueGetter: (params) => {
                const rooms = params.value;
                return rooms.map(room => room.name).join(', ');
            }
        }
    ];

    return <EntityTable
        data={ratePlan.restrictions}
        columns={columns}
        dataGridProps={{
            hideFooter: true,
            disableSelectionOnClick: true
        }}
        onEntityCreateSuccess={onCreateRestriction}
        onEntityUpdateSuccess={onUpdateRestriction}
        onEntityDeleteSuccess={onDeleteRestriction}
        enableCreateEntity
        enableEditEntity
        enableDeleteEntity
        deleteEntityAction={deleteRestriction}
        EditorComponent={RestrictionEditor}
        editorProps={{
            ratePlan: ratePlan,
            propertyId: propertyId,
        }}
        noEntitiesMessage='No restrictions are assigned to the rate plan yet'
        onError={onError}
    />
}

export default RestrictionsList;